import React, { useEffect } from 'react';

const OAuthCallback = () => {
  useEffect(() => {
    console.log('🌉 EBM OAuth Bridge React - Processing callback...');
    
    // Process OAuth callback immediately without any UI delay
    processOAuthCallback();
  }, []);

  const processOAuthCallback = () => {
    try {
      // Extract URL parameters
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const error = urlParams.get('error');
      const state = urlParams.get('state');
      
      console.log('🌉 OAuth callback received:', { 
        code: code ? 'present' : 'missing', 
        error, 
        state,
        fullUrl: window.location.href
      });
      
      // Parse state parameter to extract extension_id
      let extensionId = null;
      let providerName = null;
      
      if (state) {
        try {
          const stateData = JSON.parse(decodeURIComponent(state));
          extensionId = stateData.extension_id;
          providerName = stateData.provider;
          console.log('🌉 Parsed state data:', { extensionId, providerName });
        } catch (e) {
          console.log('🌉 Failed to parse state as JSON, treating as simple string:', state);
          providerName = state; // Fallback for simple state values
        }
      }
      
      // Build extension URL using dynamic extension ID or fallback
      let baseUrl;
      
      if (extensionId) {
        // Use dynamic extension ID from state parameter
        const idMatch = extensionId.match(/safari-web-extension:\/\/([^\/]+)\//);
        const cleanExtensionId = idMatch ? idMatch[1] : extensionId;
        baseUrl = `safari-web-extension://${cleanExtensionId}/authentication.html#/sign-in`;
        console.log('🌉 Using dynamic extension ID from state:', cleanExtensionId);
      } else {
        // Fallback to hardcoded ID (should match your wxt.config.ts key)
        baseUrl = 'safari-web-extension://acium-ebm-extension/authentication.html#/sign-in';
        console.log('🌉 Using fallback extension ID');
      }
      
      // Build query parameters manually to append after hash
      const params = new URLSearchParams();
      if (error) {
        params.set('error', error);
        if (state) params.set('state', providerName || state);
      } else if (code) {
        params.set('code', code);
        if (state) params.set('state', providerName || state);
      }
      
      // Construct final URL with parameters after hash
      const finalUrl = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;
      
      console.log('🌉 Final redirect URL:', finalUrl);
      console.log('🌉 Redirecting immediately...');
      
      // Redirect immediately without any visual feedback
      window.location.href = finalUrl;
      
    } catch (err) {
      console.error('🌉 Error processing OAuth callback:', err);
      // Even on error, try to redirect to extension with error info
      window.location.href = 'safari-web-extension://acium-ebm-extension/authentication.html#/sign-in?error=processing_failed';
    }
  };

  // Return completely invisible component - no UI at all
  return null;
};

export default OAuthCallback;
